var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExclamationmarkExceptionColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Administrateur---Param\\xE8tres",
    transform: "translate(-815.500000, -302.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(776.000000, 271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(36.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,5 L25.5,5 C26,5 26.3333333,5.16666667 26.6666667,5.5 L34.5,13.3333333 C34.8333333,13.6666667 35,14 35,14.5 L35,25.5 C35,26 34.8333333,26.3333333 34.5,26.6666667 L26.6666667,34.5 C26.3333333,34.8333333 26,35 25.5,35 L14.5,35 C14,35 13.6666667,34.8333333 13.3333333,34.5 L5.5,26.6666667 C5.16666667,26.3333333 5,26 5,25.5 L5,14.5 C5,14 5.16666667,13.6666667 5.5,13.3333333 L13.3333333,5.5 C13.6666667,5.16666667 14,5 14.5,5 Z",
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 13.3333333,
    x2: 20,
    y2: 20,
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 26.6666667,
    x2: 20.0166667,
    y2: 26.6666667,
    id: "Path",
    stroke: "#AFBC9D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationmarkExceptionColor);
export default __webpack_public_path__ + "static/media/icon_exclamationmark_exception_color.3da5fb6a6b64626d049d7834aae008cd.svg";
export { ForwardRef as ReactComponent };